import { reduxBatch } from '@manaflair/redux-batch'
import { applyMiddleware, compose, createStore } from 'redux'
import { persistStore } from 'redux-persist'
import thunk from 'redux-thunk'
import reducers from './reducers'
import sagaMiddleware from './sagaMiddleware'

export default (initialState = {}) => {
  const composeEnhancers = typeof window === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ !== 'undefined' ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose

  const middleware = applyMiddleware(sagaMiddleware, thunk)

  const enhancer = composeEnhancers(
    reduxBatch,
    middleware,
    reduxBatch
  )

  const store = createStore(reducers(), initialState, enhancer)

  const persistor = persistStore(store)

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default

      store.replaceReducer(reducers)
    })
  }

  return { store, persistor }
}
